import { InjectionToken } from '@angular/core';

export const Additional_Permissions = new InjectionToken('Additional_Permissions');
export const Nodes = new InjectionToken('nodes');
